<template>
  <div>
    <vs-prompt
      title="Select version"
      @accept="accept"
      :active.sync="active"
      accept-text="View version"
      :is-valid="validForm"
      class="todoPopup"
    >
      <vs-row v-if="active">
        <vs-col vs-w="12">
          <vs-select v-if="lists" label="Version" class="w-full" v-model="selectedList">
            <vs-select-item
              :key="item.id"
              :value="item"
              :text="`Version ${item.version} ${
                item.version == newestPublishedVersion ? '- newest published' : ''
              } (${formatDate(item.createdAction.timestamp)})`"
              v-for="item in lists"
            />
          </vs-select>
        </vs-col>
      </vs-row>
    </vs-prompt>
  </div>
</template>

<script>
import _ from "lodash";
import moment from "moment";

export default {
  components: {},
  data() {
    return {
      selectedList: "",
      currentList: null,
      lists: [],
      active: false,
    };
  },
  computed: {
    validForm() {
      return this.selectedList && this.selectedList !== "";
    },

    maxVersion() {
      if (!this.lists || this.lists.length == 0) return 0;
      var max = _.maxBy(this.lists, "version");
      if (!max) return 0;
      return max.version;
    },

    newestPublishedVersion() {
      if (!this.lists || this.lists.length == 0) return 0;
      var max = _.maxBy(
        this.lists.filter(e => e.isPublished),
        "version",
      );

      if (!max) return 0;
      return max.version;
    },
  },
  methods: {
    show(currentList, allVersions) {
      this.currrentList = currentList;
      this.lists = allVersions;
      this.active = true;

      this.lists.sort((a, b) => b.version - a.version);
      console.log("lists", this.lists);
    },

    formatDate(date) {
      return moment(date).format("DD/MM/YYYY HH:MM");
    },

    async accept() {
      console.log("accept", this.selectedList);
      this.$router
        .push({
          name: "manage-list",
          params: { id: this.selectedList.id },
        })
        .catch(e => {
          console.log("list popup", e);
        });
    },
  },
};
</script>
